"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var _1 = require(".");
var iconMap = {
    grocery_delivery: _1.GroceryDelivery,
    home_cleaning: _1.HomeCleaning,
    prepared_meal_delivery: _1.PreparedMealDelivery,
    transportation: _1.Transportation,
    yard_work: _1.YardWork,
    customer_support: _1.Headset,
    friendly_call: _1.PhoneCall,
    community: _1.Globe,
    videos: _1.Dumbbell,
};
var OrderTypeIcon = function (_a) {
    var orderType = _a.orderType, iconProps = __rest(_a, ["orderType"]);
    var Icon = iconMap[orderType];
    if (!Icon)
        return null;
    return react_1.default.createElement(Icon, __assign({}, iconProps));
};
exports.default = OrderTypeIcon;
//# sourceMappingURL=OrderType.js.map